<template>
  <div class="center-cmp">
    <div class="cursor-pointer m-2 back">
      <!-- <dv-decoration-11 style="width: 200px; height: 60px"
        ></dv-decoration-11
      > -->
      <!-- <dv-decoration-7 style="width: 150px; height: 30px"
        >返回
      </dv-decoration-7> -->
    </div>

    <div class="map-canvas" v-if="visibleCustom">
      <template v-if="mapInfo && mapInfo.key == 'street'">
        <ComponentStreetMap
          :coordinate="coordinateList[mapInfo.list[0].name]"
          :name="mapInfo.list[0].name"
          @clickStreet="changeMap(mapInfo.list[0])"
          ref="ComponentStreetMap"
        />
      </template>
      <template v-else>
        <img
          :src="mapInfo && mapInfo.bgImg"
          alt=""
          class="map select-none animate__pulse animate__infinite pointer-events-none"
          style="z-index: 22"
        />
        <div
          class="indicator__container"
          v-for="(item, index) in mapInfo.list"
          :key="index"
          :style="item.position"
          @click="changeMap(item)"
        >
          <div class="indicator__item">
            <div class="button">
              <span class="name">{{ item.name }}</span>
            </div>
            <div class="circle-container">
              <ComponentCircle></ComponentCircle>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="map-canvas" v-else>
      <ComponentMap @clickMap="changeMap"></ComponentMap>
    </div>

    <!-- <DialogEmpty :show.sync="visibleEmpty"></DialogEmpty> -->
    <ComponentSelectCommunity
      :show.sync="visibleCommunity"
    ></ComponentSelectCommunity>
    <ComponentDialogSelect
      :show.sync="visibleStreet"
      @onSave="visibleCustom = true"
    ></ComponentDialogSelect>
    <ComponentDialogPlotSelect
      :show.sync="visiblePlot"
    ></ComponentDialogPlotSelect>
    <ComponentDialogPlotSelect
      :show.sync="visiblePlot"
    ></ComponentDialogPlotSelect>
    <ComponentsDialogSelectBuilding
      :show.sync="visibleBuilding"
    ></ComponentsDialogSelectBuilding>
  </div>
</template>

<script>
import LabelTag from "./LabelTag";
import { Message } from "element-ui";
import { mapGetters } from "vuex";
import DialogEmpty from "./DialogEmpty.vue";
import Guideboard from "./Guideboard.vue";
import ComponentSelectCommunity from "./ComponentSelectCommunity.vue";
import ComponentDialogSelect from "./DialogSelect.vue";
import ComponentDialogPlotSelect from "./DialogPlotSelect.vue";
import ComponentsDialogSelectBuilding from "./DialogSelectBuilding.vue";
import ComponentCircle from "../common/Circle.vue";
import ComponentMap from "../common/Map.vue";
import ComponentStreetMap from "./StreetMap.vue";
import { coordinateList } from "../../mock.js";

import "animate.css";

export default {
  name: "CenterCmp",
  components: {
    ComponentCircle,
    DialogEmpty,
    Guideboard,
    ComponentSelectCommunity,
    ComponentDialogSelect,
    ComponentDialogPlotSelect,
    ComponentsDialogSelectBuilding,
    ComponentMap,
    ComponentStreetMap,
  },

  data() {
    return {
      coordinateList,
      visibleBuilding: false,
      visiblePlot: false,
      visibleStreet: false,
      visibleEmpty: false,
      visibleCommunity: false,
      visibleCustom: false, // 是否显示自定义街道
      mapConfig: {
        main: {
          list: [
            {
              name: "跳蹬镇",
              position: "bottom: 200px; left: 280px;",
              key: "tiaodeng",
              rowKey: "跳磴镇",
              level: 1,
            },
            {
              name: "建胜镇",
              position: "bottom: 320px;right: 280px;",
              key: "jiansheng",
              rowKey: "建胜镇",
              level: 1,
            },
            {
              name: "茄子溪街道",
              position: "top: 160px;right: 260px;",
              key: "liupeiqie",
              rowKey: "茄子溪街道",
              level: 1,
            },
            {
              name: "春晖路街道",
              position: "top: 160px;right: 400px;",
              key: "chunhui",
              rowKey: "春晖路街道",
              level: 1,
            },
            {
              name: "九宫庙街道",
              position: "top: 100px;right: 320px;",
              key: "jiugong",
              rowKey: "九宫庙街道",
              level: 1,
            },
            {
              name: "新山村街道",
              position: "top: 50px;right: 360px;",
              key: "xinshancun",
              rowKey: "新山村街道",
              level: 1,
            },
            {
              name: "跃进村街道",
              position: "top: 10px;right: 200px;",
              key: "yuejin",
              rowKey: "跃进村街道",
              level: 1,
            },
            {
              name: "八仙镇街道",
              position: "top: 10px;right: 410px;",
              key: "baxian",
              rowKey: "八仙镇",
              level: 1,
            },
          ],
          bgImg: require("../../assets/imgs/dadukou.png"),
        },
        tiaodeng: {
          bgImg: require("../../assets/imgs/tiaodengzheng.png"),
          list: [
            {
              name: "跳蹬镇",
              position: "bottom: 300px; left: 280px;",
              rowKey: "跳磴镇",
              level: 2,
            },
          ],
        },
        jiansheng: {
          bgImg: require("../../assets/imgs/jianshengzheng.png"),
          list: [
            {
              name: "建胜镇",
              position: "bottom: 300px; left: 280px;",
              rowKey: "建胜镇",
              level: 2,
            },
          ],
        },
        liupeiqie: {
          bgImg: require("../../assets/imgs/qiezixi.png"),
          list: [
            {
              name: "茄子溪街道",
              position: "bottom: 300px; left: 280px;",
              rowKey: "茄子溪街道",
              level: 2,
            },
          ],
        },
        chunhui: {
          bgImg: require("../../assets/imgs/chunhuilu.png"),
          list: [
            {
              name: "春晖路街道",
              position: "bottom: 300px; left: 280px;",
              rowKey: "春晖路街道",
              level: 2,
            },
          ],
        },
        jiugong: {
          bgImg: require("../../assets/imgs/jiugongmiao.png"),
          list: [
            {
              name: "九宫庙街道",
              position: "bottom: 300px; left: 380px;",
              rowKey: "九宫庙街道",
              level: 2,
            },
          ],
        },
        xinshancun: {
          bgImg: require("../../assets/imgs/xingshancun.png"),
          list: [
            {
              name: "新山村街道",
              position: "bottom: 300px; left: 320px;",
              rowKey: "新山村街道",
              level: 2,
            },
          ],
        },
        yuejin: {
          bgImg: require("../../assets/imgs/yuejincun.png"),
          list: [
            {
              name: "跃进村街道",
              position: "bottom: 300px; left: 320px;",
              rowKey: "跃进村街道",
              level: 2,
            },
          ],
        },
        baxian: {
          bgImg: require("../../assets/imgs/baqiaozheng.png"),
          list: [
            {
              name: "八仙镇街道",
              position: "bottom: 300px; left: 320px;",
              rowKey: "八桥镇",
              level: 2,
            },
          ],
        },
        house: {
          bgImg: require("../../assets/imgs/house.png"),
          list: [
            {
              name: "",
              position: "bottom: 300px; left: 320px;",
              level: 4,
            },
          ],
        },
        street: {
          // bgImg: require("../../assets/imgs/coordinate.png"),
          bgImg: require("../../assets/imgs/home1.png"),
          key: "street",
          list: [
            {
              name: "",
              position: "bottom: 300px; left: 320px;",
              level: 3,
            },
          ],
        },
      },
      mapInfo: {},
    };
  },
  computed: {
    ...mapGetters([
      "key",
      "mapKey",
      "communityKey",
      "plotKey",
      "tapMapCount",
      "largeConfig",
    ]),
  },
  watch: {
    key: {
      handler(v) {
        this.getMapInfo(v);
      },
    },
    communityKey: {
      handler(v) {
        if (v) {
          this.mapConfig["street"].list[0].name = this.communityKey;
          // this.getMapInfo("street");
        }
      },
    },
    plotKey: {
      handler(v) {
        if (v) {
          this.mapConfig["house"].list[0].name = this.plotKey;
          // this.getMapInfo("house");
        }
      },
    },
  },
  methods: {
    getMapItem(key = "main") {
      return this.mapConfig[key];
    },
    handleClickMap(v) {
      this.visibleStreet = true;
      this.$store.dispatch("app/changeMapKey", v.name);
      this.visibleCustom = true;
      this.$store.commit("app/SET_KEY", "house");
      this.$store.commit("app/SET_PLOT_KEY", v.name);

      return;
    },
    changeMap(item) {
      let key = item.key;
      let rowKey = item.rowKey;
      if (item.level == 2) {
        this.visibleStreet = true;
        this.$store.dispatch("app/changeMapKey", rowKey);
        this.$store.commit("app/SET_KEY", key);
        return;
      }
      if (item.level == 1) {
        this.$store.dispatch("app/changeMapKey", rowKey);
        this.$store.dispatch("app/getGlobalData").then((resp) => {
          if (!resp) {
            // this.visibleEmpty = true;

            this.$store.commit("app/SET_KEY", "main");
            return;
          } else {
            this.$store.commit("app/SET_KEY", key);
            this.getMapInfo(key);
          }
        });
      }
      if (item.level == 3) {
        this.visiblePlot = true;
      }
      if (item.level == 4) {
        // this.$store.dispatch("app/getGlobalData").then((resp) => {
        //   this.visibleBuilding = true;
        // });
        this.visibleBuilding = true;
      }
      // this.$store.dispatch("app/getVisitUsers");

      // this.$store.dispatch("app/getGlobalData", {
      //   key: key,
      //   isAssign: false,
      // });

      return;

      this.visibleEmpty = true;
      return;
      this.key = key;
      this.getMapInfo(key);
    },
    getMapInfo(key) {
      this.mapInfo = this.getMapItem(key);
    },
    onBack() {
      this.$store.dispatch("app/initAddress");
      this.$store.commit("app/SET_KEY", "main");
      this.mapInfo = this.mapConfig["main"];
      this.$store.dispatch("app/getGlobalData").then((resp) => {
        this.getMapInfo();
      });
      this.visibleCustom = false;
      this.$store.commit("app/SET_TAP_MAP_COUNT", 0);
    },
  },
  mounted() {
    this.getMapInfo();
  },
};
</script>

<style lang="less">
.center-cmp {
  width: 100%;
  height: 100%;
  background: #fff;
  .circle-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 30px;
    left: 30px;
  }
  .button span {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ff8c00;
    border-radius: 0.2em;
    font-size: 1.5em;
    padding: 0px 4px;
    color: #fff;
    border: 0.08em solid #fff;
    box-shadow: 0 0.4em 0.1em 0.019em #fff;
  }

  .button span:hover {
    transition: all 0.5s;
    transform: translate(0, 0.4em);
    box-shadow: 0 0 0 0 #fff;
  }

  button span:not(hover) {
    transition: all 1s;
  }

  .back {
    position: absolute;
    left: 440px;
    top: 110px;
    z-index: 30;
    font-weight: bold;
  }
  .map-canvas {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    margin-top: 0px;
  }
  .map {
    height: 100%;
    // width: 100%;
    position: absolute;
    left: 50%;
    top: 4%;
    transform: translateX(-50%);
  }
  .indicator__container {
    position: absolute;
    cursor: pointer;
    // background-image: url("../../assets/imgs/pointer.png");
    // background-repeat: no-repeat;
    // height: 60px;
    // padding-top: 30px;
    // padding-left: 40px;
    // font-size: 12px;
    z-index: 30;
  }
  .indicator__item {
    position: relative;
    min-width: 110px;
    // height: 60px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .button {
      width: 100%;
      height: 100%;
    }
    .name {
      position: absolute;
      z-index: 2;
      top: 12px;
      left: 20px;
      font-size: 12px;
    }
    .pointer {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
